import Graphic from "@arcgis/core/Graphic";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";
/* eslint-disable */
/**
 *
 * @param {Object} object with url (url of the layer) , objectId of the feature , attachmentIds (array of attachmentIds)
 */
export default async function deleteAttachmentEsri({
  url,
  objectId,
  attachmentIds,
}) {
  const graphic = new Graphic();
  graphic.attributes = {};
  graphic.attributes.OBJECTID = objectId;
  try {
    const featureLayer = new FeatureLayer({
      url,
    });
    await featureLayer.deleteAttachments(graphic, attachmentIds);
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
}
